<template>
    <el-drawer :modal="false" 
        title="Edit Case"
        :visible.sync="is_visible"
        class="drawer-edit-case"
        size="50%"
    >
        <div slot="title">
            <b-row align-h="between" align-v="center">
                <b-col lg="4">
                    <span>Edit Case</span><br>
                    <p class="text-xs text-muted">0346-HPL</p>
                </b-col>
                <b-col lg="4">
                    <div class="d-flex align-items-center text-primary float-right cursor-pointer" @click="$refs.drawer_activity_log.show()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                        <p class="text-primary ml-2">View Change Log</p>
                    </div>
                </b-col>
            </b-row>
						<div class="alert alert-warning" v-if="is_readonly">Loan disbursement status is "Full Disbursement", Loan cannot be edited</div>
        </div>
        <b-container>
            <b-row class="mx-2">
                <b-col cols="12" class="border-bottom">
                    <h3>Loan Detail Summary</h3>
                </b-col>
            </b-row>
            <b-row class="m-3">
                	<b-col cols="12">
										<b-card-group deck>
											<b-card>
												<div class="mb-2">
													<p class="text-muted text-xs">Loan Amount</p>
													<p class="font-weight-600">RM {{ _gHlp.getValue(activeCase, 'loan_amount', 0) | moneyFormatter }}
													</p>
												</div>
												<div class="mb-2">
													<p class="text-muted text-xs">Interest Rate</p>
													<p class="font-weight-600">{{ _gHlp.getValue(activeCase, 'interest_rate', 0) }} %</p>
												</div>
												<div class="mb-2">
													<p class="text-muted text-xs">Interest Amount</p>
													<p class="font-weight-600">RM {{ _gHlp.getValue(activeCase, 'total_interest_amt', 0) | moneyFormatter }}
													</p>
												</div>
											</b-card>
											<b-card>
												<div class="mb-2">
													<p class="text-muted text-xs">Installment Amount</p>
													<p class="font-weight-600">RM {{ _gHlp.getValue(activeCase, 'installment_amount', 0) | moneyFormatter }}
													</p>
												</div>
												<div class="mb-2">
													<p class="text-muted text-xs">Total Amount Paid</p>
													<p class="font-weight-600">RM {{ total_amount_paid | moneyFormatter
														}}
													</p>
												</div>
												<div class="mb-2">
													<p class="text-muted text-xs">Credit Loan DC Amount</p>
													<p class="font-weight-600">RM {{ total_debt_console | moneyFormatter }} </p>
												</div>
											</b-card>
											<b-card>
												<div class="mb-2">
													<p class="text-muted text-xs">Moratorium Tenure</p>
													<p class="font-weight-600">{{ _gHlp.getValue(activeCase, 'moratorium_tenure', 0) }} </p>
												</div>
												<div class="mb-2">
													<p class="text-muted text-xs">Moratorium Installment</p>
													<p class="font-weight-600">RM {{ _gHlp.getValue(activeCase, 'moratorium_inst', 0) |
														moneyFormatter }} </p>
												</div>
												<div class="mb-2">
													<p class="text-muted text-xs">Moratorium Start Period</p>
													<p class="font-weight-600">{{ _gHlp.getValue(activeCase, 'moratorium_start', 0) }} </p>
												</div>
											</b-card>
                    </b-card-group>
                </b-col>
            </b-row>
            <el-collapse v-model="activeSections">
                <el-collapse-item name="loan_detail" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Loan Detail</h3>
                    </div>
                    <LoanDetail :loanTypes="loanTypes" :is_readonly="is_readonly"/>
                </el-collapse-item>
                <!-- <el-collapse-item name="2" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Arrangement Fee</h3>
                    </div>
                    <ArrangementFee :activeCase="activeCase" :is_readonly="is_readonly"/>
                </el-collapse-item>
                <el-collapse-item name="3" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Admin &amp; Legal Fee</h3>
                    </div>
                    <AdminLegalFee :activeCase="activeCase" :is_readonly="is_readonly"/>
                </el-collapse-item> -->
            </el-collapse>
        </b-container>
				<DrawerActivityLog ref="drawer_activity_log" :tags="'#loan_case_' + _gHlp.getValue(activeCase, 'case_id')" />
    </el-drawer>
</template>
<script>
import { Drawer, Button, Collapse, CollapseItem } from 'element-ui'
import DrawerActivityLog from '@/views/CustomerProfile/Drawers/DrawerActivityLog/ActivityLog'
import LoanDetail from '@/views/CreditLoanCase/Drawers/DrawerEditCase/Forms/LoanDetail'
import ArrangementFee from '@/views/CreditLoanCase/Drawers/DrawerEditCase/Forms//ArrangementFee'
import AdminLegalFee from '@/views/CreditLoanCase/Drawers/DrawerEditCase/Forms//AdminLegalFee'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
import { useCommonStore } from '@/stores/commonStore'

export default {
    components: {
        LoanDetail,
        ArrangementFee,
        AdminLegalFee,
				DrawerActivityLog,
        [Drawer.name]: Drawer,
        [Button.name]: Button,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
    },
    data() {
        return {
            is_visible: false,
						activeSections:['loan_detail']
        }
    },
		created() {
			gEventBus.$on('close_edit_case', this.close)
		},
		beforeDestroy() {
			gEventBus.$off('close_edit_case', this.close)
		},
		computed: {
				...mapState(useLoanCaseStore, ['activeCase','activeDisbursements']),
				...mapState(useCommonStore, ['loanTypes']),
				is_readonly(){
					if(_gHlp.isEmpty(this.activeDisbursements)) return false;
					let loan_amount = parseFloat(_gHlp.getValue(this.activeCase,'loan_amount',0));
					return !_gHlp.isEmpty(this.total_apv_debt_console) && (loan_amount > 0) && (this.total_apv_debt_console == loan_amount);
				},
				total_amount_paid(){
					let loan_amount = parseFloat(_gHlp.getValue(this.activeCase,'loan_amount',0));
					let total_interest_amt = parseFloat(_gHlp.getValue(this.activeCase,'total_interest_amt',0));
					return loan_amount + total_interest_amt
				},
				total_debt_console(){
					let total = 0;
					if (!_gHlp.isEmpty(this.activeDisbursements)) {
						total = this.activeDisbursements.reduce((tot, obj) => {
							return (obj.description != 'Balance Disbursement') ? (tot + parseFloat(obj.amount)) : tot
						}, 0)
					}
					return parseFloat(total).toFixed(2);
				},
				total_apv_debt_console(){
					let total = 0;
					if (!_gHlp.isEmpty(this.activeDisbursements)) {
						total = this.activeDisbursements.reduce((tot, obj) => {
							return (obj.status == 'Approved') ? (tot + parseFloat(obj.amount)) : tot
						}, 0)
					}
					return parseFloat(total).toFixed(2);
				}
		},		
    methods: {
			close(){
				this.is_visible = false
			},
			viewEditCase() {
				this.is_visible = true;
			}
    }
}
</script>